import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import moment from 'moment';

import { Form } from 'common/components';

class AssetsDepreciationEndDate extends PureComponent {
  static propTypes = {
    handleEndDateChange: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  render = () => (
    <div className="col-12 bbottom mb-3 mt-3">
      <div className="row">
        <div className="col-sm-12">
          <h5>
            <b>{this.props.t('assets.depreciation_values')}</b>
          </h5>
          <br />
        </div>
        <div className="col-sm-6 col-md-4 offset-md-2">
          <Form.FieldInput
            name={'startDate'}
            label={this.props.t('assets.fields.startDate')}
            value={moment(this.props.startDate).format('DD/MM/YYYY')}
            readOnly={true}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.FieldDate
            handleChange={this.props.handleEndDateChange}
            name={'endDate'}
            label={this.props.t('assets.fields.endDate')}
            value={this.props.endDate}
          />
        </div>
      </div>
    </div>
  );
}

export default translate()(AssetsDepreciationEndDate);



// WEBPACK FOOTER //
// src/components/assets/depreciation/AssetsDepreciationEndDate.js